<template>
  <div class="alert alert-danger" v-if="percentage >= 1.5">
    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
    <h4><i class="icon fa fa-warning"></i>Achtung - Ihr Account wird deaktiviert!</h4>
    <p>Ihre Stornierungsquote hat ein kritisches Maß überschritten: <strong>{{percentage | currency('%')}}</strong></p>
  </div>
  <div class="alert alert-warning" v-else>
    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
    <h4><i class="icon fa fa-warning"></i>Achtung - Ihre Stornoquote überschreitet {{percentage | currency('%')}}!</h4>
    <p>{{warningMessage[0]}}<br><strong>{{warningMessage[1]}}</strong><br>{{warningMessage[2]}}</p>
  </div>
</template>
<script>
export default {
  props: ['percentage'],
  data () {
    return {
      warningMessage: [
        'In der Vertragsgestaltung mit zalando hat sich die ANWR Media dazu verplichtet, eine Stornoqoute von weniger als 1% zu erfüllen.',
        'Sollte Ihre Stornierungsquote weiterhin ansteigen, sind wir dazu gezwungen, Ihren Account zu deaktivieren und Sie von der Teilnahme am Verkauf auf zalando auszuschließen.',
        'Bitte prüfen Sie Ihre übermittelten Bestände an schuhe.de.'
      ]
    }
  },
  methods: {
  },
  watch: {
    percentage (value) {
      this.percentage = value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/ErrorBox.vue